module.exports = __webpack_public_path__ + "static/media/livecalls.d52b244e.svg";